import { styled as d, css as c } from "styled-components";
import { FloatingArrow as g } from "./atoms-v280.js";
import { breakpoints as s } from "./atoms-v2125.js";
import { CELL_FACE_PADDING as i } from "./atoms-v21333.js";
const f = 6, x = 2;
function a(r) {
  return r ? `${i}px` : "0";
}
function p(r) {
  return r ? `${i}px` : "0";
}
const k = d.td`
  box-sizing: content-box !important;
  height: 48px;
  padding: ${i}px
    ${({ $isDisabledForOverflow: r, $isEndDate: o }) => a(o && !r)}
    ${i}px
    ${({ $isDisabledForOverflow: r, $isStartDate: o }) => p(o && !r)};

  @media ${s.medium} {
    height: 60px;
    padding: 0
      ${({ $isDisabledForOverflow: r, $isEndDate: o }) => a(o && !r)} 0
      ${({ $isDisabledForOverflow: r, $isStartDate: o }) => p(o && !r)};
  }

  ${({ $isNotAllowed: r }) => r && c`
      &,
      & * {
        cursor: not-allowed !important;
      }
    `}
`, b = d.div`
  background-color: ${({ $colorTheme: r, theme: o }) => {
  var n;
  return (n = o == null ? void 0 : o.get) == null ? void 0 : n.call(o, `tokens.surface.${r}.background`);
}};
  border-radius: 0;
  color: ${({ $colorTheme: r, theme: o }) => {
  var n;
  return (n = o == null ? void 0 : o.get) == null ? void 0 : n.call(o, `tokens.text.${r}.primary`);
}};
  padding: 16px;
  z-index: ${({ theme: r }) => r == null ? void 0 : r.get("tokens.zindex.tooltip")};

  ${({ theme: r }) => {
  var o;
  return (o = r == null ? void 0 : r.get("tokens.body.compact-productive")) == null ? void 0 : o.toJS();
}}
`, T = d(g)`
  fill: ${({ $colorTheme: r, theme: o }) => {
  var n;
  return (n = o == null ? void 0 : o.get) == null ? void 0 : n.call(o, `tokens.surface.${r}.background`);
}};
  stroke: ${({ $colorTheme: r, theme: o }) => {
  var n;
  return (n = o == null ? void 0 : o.get) == null ? void 0 : n.call(o, `tokens.surface.${r}.background`);
}};
`;
export {
  f as TOOLTIP_ARROW_HEIGHT,
  x as TOOLTIP_ARROW_MARGIN,
  k as TableDataCell,
  b as Tooltip,
  T as TooltipArrow
};
